<template>
    <div class="m-help-container">
        <span
            data-toggle="popover"
            data-trigger="focus"
            role="button"
            tabindex="0"
            title="Help Description"
            :data-content="description"
            data-html="true"
            class="text-info fa fa-question-circle m-help-action">

        </span>
    </div>
</template>

<script>
export default {
    name: "HelpComponent",
    props: ['description']
}
</script>
<style>

.popover {
    width: 800px !important;
    max-width: none !important;
    overflow-y: scroll  !important;
    height: 95% !important;
}
</style>
<style scoped>
 .m-help-container{
     display: inline-block;
 }

 .m-help-container .m-help-action{
     cursor: pointer;
 }
</style>
